import type {} from "@lit/react";
import { Tab as TabElement, } from "@vaadin/tabs/vaadin-tab.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { TabElement, };
export type TabEventMap = Readonly<{}>;
const events = {} as TabEventMap;
export type TabProps = WebComponentProps<TabElement, TabEventMap>;
export const Tab = createComponent({
    elementClass: TabElement, events, react: React, tagName: "vaadin-tab"
});
